module.exports = __webpack_public_path__ + "a768e7de/img/saly-icon.39e12342.jpg";